import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP } from 'src/app/config/app';
import { ILegacyValueRule } from 'src/app/models';

@Injectable()
export class LegacyValuesInterceptor implements HttpInterceptor {
  private rulesByKey = new Map<string, ILegacyValueRule[]>();

  constructor() {
    APP.LEGACY_VALUE_RULES.forEach((rule) => {
      this.rulesByKey.set(rule.key, [...(this.rulesByKey.get(rule.key) ?? []), rule]);
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse && event.body && typeof event.body === 'object') {
          this.replaceLegacyValues(event.body);
        }
        return event;
      })
    );
  }

  private replaceLegacyValues(value: any): void {
    if (Array.isArray(value)) {
      value.forEach((item) => this.replaceLegacyValues(item));
      return;
    }
    if (!value || typeof value !== 'object') return;
    Object.keys(value).forEach((key) => {
      const property = value[key];
      if (property && typeof property === 'object') {
        this.replaceLegacyValues(property);
        return;
      }
      const rule = this.rulesByKey.get(key)?.find((candidate) => this.matches(property, candidate.legacyValue));
      if (rule) value[key] = rule.value;
    });
  }

  private matches(property: any, legacyValue: string): boolean {
    return typeof property === 'string' && property.toUpperCase() === legacyValue.toUpperCase();
  }
}
